export const SME_PERMISSIONS = {
  accountsView: "sme.accounts.view",
  accountsViewSensitiveDetails: "sme.accounts.viewSensitiveDetails",
  transactionsView: "sme.transactions.view",
  transactionsExport: "sme.transactions.export",
  beneficiariesView: "sme.beneficiaries.view",
  beneficiariesCreate: "sme.beneficiaries.create",
  beneficiariesManage: "sme.beneficiaries.manage",
  paymentsCreate: "sme.payments.create",
  paymentsSubmit: "sme.payments.submit",
  paymentsApprove: "sme.payments.approve",
  paymentsCancel: "sme.payments.cancel",
  cardsView: "sme.cards.view",
  cardsManage: "sme.cards.manage",
  cardsReveal: "sme.cards.reveal",
  reportsView: "sme.reports.view",
  reportsExport: "sme.reports.export",
  teamView: "sme.team.view",
  teamInvite: "sme.team.invite",
  teamManagePermissions: "sme.team.managePermissions",
} as const;

export const OPS_PERMISSIONS = {
  workView: "ops.work.view",
  workAssignSelf: "ops.work.assignSelf",
  workAssignOthers: "ops.work.assignOthers",
  companiesView: "ops.companies.view",
  kybView: "ops.kyb.view",
  kybApprove: "ops.kyb.approve",
  kybReject: "ops.kyb.reject",
  accountsView: "ops.accounts.view",
  accountsManageStatus: "ops.accounts.manageStatus",
  paymentsView: "ops.payments.view",
  paymentsInvestigate: "ops.payments.investigate",
  paymentsRetry: "ops.payments.retry",
  cardsView: "ops.cards.view",
  cardsBlock: "ops.cards.block",
  riskView: "ops.risk.view",
  riskDecide: "ops.risk.decide",
  reportsExport: "ops.reports.export",
  auditView: "ops.audit.view",
  auditExport: "ops.audit.export",
  configurationManage: "ops.configuration.manage",
} as const;

export type SmePermission =
  (typeof SME_PERMISSIONS)[keyof typeof SME_PERMISSIONS];

export type OpsPermission =
  (typeof OPS_PERMISSIONS)[keyof typeof OPS_PERMISSIONS];
